import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
import './taload.css';
// import DeviceDetails from "./DeviceDetails";
import history from "../../auth/history";
import { store } from "../../redux/store";
import HeadeCommon from "../HeaderComponent/HeadeCommon";
import Menu from "../MenuComponent/Menu";
import FooterComponet from "../FooterComponent/FooterComponet";
import DatePicker from 'react-datepicker';
import './react-datepicker.css';
import { setTxnLoader } from "../../redux/misc-data/misc-data.action";
import BankLogo from "../../assests/images/bank-logo.png";
import Pagination from "react-js-pagination";

const httpClient = axios.create();
class TALoad extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            scheduled: null,
            startDate: new Date(),
            val: '',
            taloadErr: '',
            taLoadList: [],
            taLoadingState: 'loading',
            startIndex: 0,
            endIndex: 10,
            activePage: 1,
            searchVal: '',
            curYear:'',
            curMonth:''

        }
    }



    componentDidMount() {


        var date = new Date();
        var month = String(date.getMonth() + 1);
        var day = String(date.getDate());
        var year = String(date.getFullYear());

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        this.setState({
            curYear:year,
            curMonth:month
        })

        this.loadTA(year, month);

    }
    componentWillUnmount() {
    }

    exportToCSV=(event)=> {
        event.preventDefault();

        var taLoadList=[];

        if(this.state.taLoadList.length>0){

            this.state.taLoadList.map(taLoad=>{


            var id=taLoad.id;
            var entityId=taLoad.entityId;
            var refId=taLoad.refId;
            var txnMode=taLoad.txnMode;
            var bank   = taLoad.bank;
            var utr   = taLoad.utr;
            var txnDate   = taLoad.txnDate;
            var amount   = taLoad.amount;
            var comment   = taLoad.comment;
            var approved   = taLoad.approved;
            var createdOn   = taLoad.createdOn;
            var updatedOn   = taLoad.updatedOn;

            var taLoadData={
                id:id,
                entityId:entityId,
                refId:refId,
                txnMode:txnMode,
                bank:bank,
                utr:utr,
                txnDate:txnDate,
                amount:amount,
                comment:comment,
                approved:approved,
                createdOn:createdOn,
                updatedOn:updatedOn,
            }

            taLoadList.push(taLoadData);
        })


        }


        var JsonFields = ["ID", "EntityId","RefId","TxnMode",
        "Bank","UTR","TxnDate","Amount",
        "Comment","Approved","CreatedOn",
        "UpdatedOn"];
        var csvStr = JsonFields.join(",") + "\n";
        taLoadList.length>0 && taLoadList.forEach(taLoad => {

            var id=taLoad.id;
            var entityId=taLoad.entityId;
            var refId=taLoad.refId;
            var txnMode=taLoad.txnMode;
            var bank   = taLoad.bank;
            var utr   = taLoad.utr;
            var txnDate   = taLoad.txnDate;
            var amount   = taLoad.amount;
            var comment   = taLoad.comment;
            var approved   = taLoad.approved;
            var createdOn   = taLoad.createdOn;
            var updatedOn   = taLoad.updatedOn;

            csvStr += id + ',' + entityId + ',' +
            refId + ',' + txnMode + ',' + bank + ',' +
            utr + ',' + txnDate + ',' +
            amount + ',' + 
            comment+ ','+
            approved + ',' +
            createdOn + ',' +
            updatedOn+','+"\n"
            })

        if(taLoadList.length>0){
            var hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvStr);
            hiddenElement.target = '_blank';
            hiddenElement.download = 'taLoadList_ouutput'+'_'+this.state.curYear+'_'+this.state.curMonth+'.csv';
            hiddenElement.click();
        }

    }

    setStartDate = (date) => {

        this.setState({
            startDate: date
        })


        var month = String(date.getMonth() + 1);
        var day = String(date.getDate());
        var year = String(date.getFullYear());

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        this.setState({
            curYear:year,
            curMonth:month
        })


        this.loadTA(year, month);


    }


    handlePageChangeDefault(pageNumber) {

        this.setState({
            activePage: pageNumber,
            startIndex: (pageNumber - 1) * 10,
            endIndex: (pageNumber) * 10
        })
    }

    loadTA = (year, month) => {

        this.setState({
            taloadErr: '',

        })
        var taloadUrl = '/api/v1/virtual-balance/claim/list/';

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        httpClient.get(taloadUrl
            + this.props.agentInfo.id +
            '/' + year + '/' + month, {
            timeout: 180 * 1000,
            timeoutErrorMessage: 'timeout',
            headers
        }
        ).then((response) => {
            console.log('ta load response' + JSON.stringify(response.data));
            if (response.data.length == 0) {
                this.setState({
                    taLoadList: [],
                    taLoadingState: 'completed'
                })
            } else {
                this.setState({
                    taLoadList: response.data,
                    taLoadingState: 'completed'
                })
            }
        }).catch(error => {
            this.setState({
                taLoadList: [],
                taloadErr: 'Something went wrong',
                taLoadingState: 'completed'
            })
        })

    }

    enterSearchValue = (event) => {
        event.preventDefault();
        this.setState({
            searchVal: event.target.value
        })
    }

    searchClient = () => {


        var searchedClient = [];
        if (this.state.searchVal != '' && this.state.searchVal.length >= 3) {
            this.state.taLoadList.map(taLoad => {
                if (taLoad.utr.includes(this.state.searchVal)) {
                    searchedClient.push(taLoad);
                }
            })
        }

        this.setState({
            taLoadList: searchedClient
        })
    }


    clearSearch=()=>{
        this.loadTA(this.state.curYear, this.state.curMonth);
    }


    render() {

        return (
            <div>
                <HeadeCommon />
                <Menu />
                <div class="main">
                    <div class="right-side">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-12">
                                    <div class="card-b" id="rightdiv">


                                        <div class="head">
                                            <h3>TA Load Request</h3>


                                            <div class='dateTimePickersearch'>
                                                <DatePicker
                                                    selected={this.state.startDate}
                                                    onChange={(date) => this.setStartDate(date)}
                                                    dateFormat="MM/yyyy"
                                                    showMonthYearPicker

                                                />

                                            </div>

                                            <div class="headsearch">

                                                <div class="input-group">
                                                    <input type="text" class="form-control" placeholder="Search client..."
                                                        value={this.state.searchVal}
                                                        onChange={this.enterSearchValue} />
                                                    <button class="btn search" type="button" id="txnsrch"
                                                        onClick={this.searchClient}
                                                        disabled={this.state.searchVal.length < 3 && true}>search</button>
                                                    <button
                                                        style={{ background: "#FF8D33", marginLeft: "3px" }}
                                                        class="btn delete"
                                                        // disabled={search.length <= 3}
                                                        type="button"
                                                        onClick={this.clearSearch}
                                                    >

                                                        clear

                                                    </button>
                                                </div>

                                            </div>
                                        </div>

                                        <div class="reqlist">

                                            {this.state.taLoadList.length == 0 &&
                                                this.state.taLoadingState == 'completed' &&

                                                <div>No Record Found</div>
                                            }
                                            {this.state.taLoadList.length == 0 &&
                                                this.state.taLoadingState == 'loading' &&

                                                <div>Loading Data...</div>
                                            }

                                            {this.state.taLoadList.length > 0 &&
                                                this.state.taLoadingState == 'completed' &&
                                                this.state.taLoadList.slice(this.state.startIndex, this.state.endIndex).map(data => (
                                                    <div class="loadlist">
                                                        <div class="row">

                                                            <div class="col-12 col-md-6 col-lg-4 col-xl-2">
                                                                <div class="loadnm">
                                                                    <img src={BankLogo} alt="logo" />
                                                                    {/* <p></p> */}
                                                                    <h5>{data.txnDate}</h5>
                                                                </div>
                                                            </div>
                                                            <div class="col-12 col-md-6 col-lg-12 col-xl-3">
                                                                <div class="tatxt">
                                                                    {/* <p>Bank Name</p> */}
                                                                    <h5>{data.bank.toUpperCase()}</h5>
                                                                </div>
                                                            </div>
                                                            <div class="col-7 col-md-3 col-lg-2 col-xl-3">
                                                                <div class="tatxt">
                                                                    {/* <p>TXN ID</p> */}
                                                                    <h5>{data.utr}</h5>
                                                                </div>
                                                            </div>
                                                            <div class="col-7 col-md-3 col-lg-2 col-xl-2">
                                                                <div class="tatxt">
                                                                    {/* <p>TXN Mode</p> */}
                                                                    <h5>{data.txnMode}</h5>
                                                                </div>
                                                            </div>
                                                            <div class="col-5 col-md-3 col-lg-2 col-xl-1">
                                                                <div class="tatxt">
                                                                    {/* <p>Claim Amount</p> */}
                                                                    <h4>₹{data.amount}</h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                ))

                                            }

                                            {
                                                this.state.taLoadingState == 'completed' &&
                                                this.state.taLoadList.length > 0 &&
                                                <div class="pager">
                                                    <p>
                                                        {"Showing " + (this.state.startIndex + 1) + " to " + (this.state.endIndex >= this.state.taLoadList.length ?
                                                            this.state.taLoadList.length : this.state.endIndex) + " of total " + this.state.taLoadList.length + " no  of entries.   "}</p>
                                                            {"     "}
                                                    <button class="lbbtn" type="button" onClick={this.exportToCSV}>Export</button>
                                                    <Pagination
                                                        activePage={this.state.activePage}
                                                        itemsCountPerPage={10}
                                                        totalItemsCount={
                                                            this.state.taLoadList.length}
                                                        pageRangeDisplayed={5}
                                                        onChange={this.handlePageChangeDefault.bind(this)}
                                                        className="pagination"
                                                        linkClass="page-link"
                                                        itemClass="page-item"
                                                    />
                                                </div>


                                            }
                                            {/* <div class="pager">
                                                <p>Showing 1 to 12 of 45 entries
                                                    <button class="lbbtn" type="button">Export</button>
                                                </p>
                                                <ul class="pagination pagination-sm">
                                                    <li class="page-item"><a class="page-link" href="#">Prev</a></li>
                                                    <li class="page-item active"><a class="page-link" href="#">1</a></li>
                                                    <li class="page-item"><a class="page-link" href="#">2</a></li>
                                                    <li class="page-item"><a class="page-link" href="#">3</a></li>
                                                    <li class="page-item"><a class="page-link" href="#">4</a></li>
                                                    <li class="page-item"><a class="page-link" href="#">Next</a></li>
                                                </ul>
                                            </div> */}

                                        </div>
                                    </div>
                                </div>




                            </div>
                        </div>
                    </div >
                </div >
                <FooterComponet />
            </div >
        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone, agentInfo, token, clientRole, clientRequesterId } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone, agentInfo, token, clientRole, clientRequesterId
});

export default connect(mapStateToProps, null)(TALoad);
